import { render, staticRenderFns } from "./TaskSortAmountIcon.vue?vue&type=template&id=493b9cc1"
import script from "./TaskSortAmountIcon.vue?vue&type=script&lang=ts"
export * from "./TaskSortAmountIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports